/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NbMenuService, NbMenuItem, NbThemeService, NbMediaBreakpointsService, NbSidebarService, NbMediaBreakpoint } from '@nebular/theme';
import { AuthService } from './@core/auth/auth.service';
import { FaviconsService } from './@core/utils/favicons.service';
import { ReportService } from './reports/report.service';
import { StateService } from './@core/data/state.service';
import { MatDialog } from '@angular/material/dialog';
import { ChangeTenantComponent } from './shared/change-tenant/change-tenant.component';
import { Router } from '@angular/router';
// import { MessagingService } from './service/firebase-service';


@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {


  message: any;
  constructor(
    private analytics: AnalyticsService,
    private menuService: NbMenuService,
    private authService: AuthService,
    private favicon: FaviconsService,
    public reportService: ReportService,
    protected stateService: StateService,
    protected themeService: NbThemeService,
    protected bpService: NbMediaBreakpointsService,
    protected sidebarService: NbSidebarService,
    private dialog: MatDialog,
    private router: Router
    // private messagingService : MessagingService

  ) {

  }

  ngOnInit() {
    this.analytics.trackPageViews();
    this.favicon.activate();

    this.menuService.onItemClick().subscribe((event) => {
      this.onContextItemSelection(event.item.title);
    })
    /************ Commenting out till we actually need to request permission for push notifications ***********/
    //this.messagingService.requestPermission();

    // this.messagingService.receiveMessage();

    // this.message = this.messagingService.currentMessage

  }


  onContextItemSelection(title) {
    if (title === 'Log out') {
      this.authService.logout();
    }

    //Open dialog for change tenant
    if (title === "Change Tenant") {
      this.dialog.open(ChangeTenantComponent, { width: "600px"});
    }

    if (title === "Tenant Management") {
      this.router.navigate(['/harvest-engine/admin-new']);
    }

    if (title === "Platform Config") {
      this.router.navigate(['/harvest-engine/platform-config']);
    }

    if (title === "Usage Metrics") {
      this.router.navigate(['/harvest-engine/usage-metrics']);
    }

    if (title === "Tenant Detail") {
      this.router.navigate(['/harvest-engine/admin']);
    }
  }

}
